import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsClaroMora = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Origen</th>
                    <th className='center'>Cuenta</th>
                    <th className='center'>Cartera</th>
                    <th className='center'>Tramo</th>
                    <th className='center'>Nº Factura</th>
                    <th className='center'>Venc. Factura</th>
                    <th className='right'>Monto Factura</th>
                    <th className='center'>Descto.</th>
                    <th className='right'>Saldo</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    {doc.linea_negocio}
                                </label>
                            </td>
                            <td className="center">{doc.cuenta}</td>
                            <td className="center">{doc.tipo_servicio}</td>
                            <td className="center">{doc.tramo}</td>
                            <td className="center">{doc.num_factura}</td>
                            <td className="center">{doc.fecha_venc}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_pend)}</td>
                            <td className="center">{doc.dscto}%</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend))}</td>
                        </tr>

                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsClaroMora;